import Vue from 'vue';
import Vuex from 'vuex';
import {GlobalHeader, CustomSideMenuGroup} from '@istyle-inc/global-navigation/sp';
import {platformApi} from '@istyle-inc/vuex-platform-api';
import {context, Platform} from '@istyle-inc/vuex-context';
import 'url-polyfill';
import 'whatwg-fetch';

const selectorGlobalHeader = '#component-global-header';

Vue.use(Vuex);

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector(selectorGlobalHeader)) {
    const wrapperHeightAdjust = document.querySelector('#cmn-page');
    const stateHeightAdjust = 'is-global-sidemenu-open';
    const elementsVideoAds = document.querySelector('#cmn-ad-hdr iframe'); // 広告動画
    const MyMenuGroup = CustomSideMenuGroup.make({
    label: 'メニュー',
      menuItems: [
        {
          label: 'ランキング',
          link: process.env.ATCOSME_SP_URL + 'ranking/'
        },
        {
          label: 'ベストコスメ',
          link: process.env.ATCOSME_SP_URL + 'bestcosme/'
        },
        {
          label: 'コスメ・クチコミ',
          link: process.env.ATCOSME_SP_URL + 'top-cosme_review/'
        },
        {
          label: 'ブランドスペシャル情報',
          link: process.env.ATCOSME_SP_URL + 'brand_info/'
        },
        {
          label: 'プレミアム限定メニュー',
          link: process.env.ATCOSME_SP_URL + 'premium/'
        },
        {
          label: '└ 期間限定クーポン',
          link: process.env.ATCOSME_SP_URL + 'premium/luck'
        },
        {
          label: 'プレゼント・モニタ－',
          link: process.env.ATCOSME_SP_URL + 'present/'
        },
        {
          label: 'ブランドファンクラブ',
          link: process.env.ATCOSME_SP_URL + 'brandfanclub/'
        },
        {
          label: '最新のクチコミ',
          link: process.env.ATCOSME_SP_URL + 'latest-reviews/'
        },
        {
          label: '特集',
          link: process.env.ATCOSME_SP_URL + 'summary/'
        }
      ]
    });
    wrapperHeightAdjust.classList.add('global-navi-overflow-hidden');
    wrapperHeightAdjust.classList.add('global-navi-relative');

    let isSideMenuOpened = false;

    const store = new Vuex.Store({
      modules: {context, platformApi},
    });
 
    store.dispatch('context/initialize', {
      platform: Platform.ATCOSME,
    });
 
    store.dispatch('platformApi/initialize', {
      clientId: process.env.PLATFORM_CLIENT_ID,
    });

    new Vue({ // eslint-disable-line no-new
      el: selectorGlobalHeader,
      components: {
        GlobalHeader
      },
      mounted: function() {
        const sideMenu = this.$refs.globalHeader.getSideMenu();
        if (!sideMenu) {
          // HTMLで hide-menu-button="true" にしている場合サイドメニューも付与されず
          // sideMenuインスタンスがとれない
          return;
        }
        sideMenu.menuGroups.splice(1,0,MyMenuGroup);
      },
      methods: {
        onSideMenuOpen: function(sideMenu) {
          isSideMenuOpened = true;
          this.stopAds();
        },
        onSideMenuOpened: function(sideMenu) {
          wrapperHeightAdjust.classList.add(stateHeightAdjust);
          this.adjustHeight(sideMenu.$el.clientHeight);
        },
        onSideMenuClose: function(sideMenu) {
          isSideMenuOpened = false;
          this.playAds();
        },
        onSideMenuClosed: function(sideMenu) {
          wrapperHeightAdjust.classList.remove(stateHeightAdjust);
          this.adjustHeight(sideMenu.$el.clientHeight);
        },
        onSideMenuContentChanged: function(sideMenu) {
          this.adjustHeight(sideMenu.$el.clientHeight);
        },
        adjustHeight: function(height) {
          wrapperHeightAdjust.style.height = isSideMenuOpened ? (height + 'px') : 'auto'; // eslint-disable-line max-len
        },
        stopAds: function() {
          this.controlAds('closeBanner');
        },
        playAds: function() {
          this.controlAds('openBanner');
        },
        controlAds: function(command) {
          if (elementsVideoAds) {
            elementsVideoAds.contentWindow.postMessage({
              message: command
            }, '*');
          }
        }
      },
      store: store,
    });
  }
});
